import { FunctionalComponent, h } from "preact";
import style from "./style.scss";

export const Title: FunctionalComponent = (props) => {
  return <div className={style.title} {...props} />;
};

export const SectionTitle: FunctionalComponent = (props) => {
  return <div className={style['section-title']} {...props} />;
};

export const Required = () => <span className={style['required']}>*</span>
